/**
 * This utility file checks whether the `window.document` is loaded within an
 * iframe, and throws an exception if that is the case.
 *
 * Throwing an exception when loading the application in an iframe is one
 * protection against clickjacking https://en.wikipedia.org/wiki/Clickjacking.
 */
const isWithinIframe = () => window.parent !== window;

const iframeBuster = () => {
	if (!isWithinIframe()) {
		return;
	}
	throw new Error("The application will not load within an iframe");
};

iframeBuster();
